import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Slide } from "@material-ui/core";
import { GetApp, Store } from '@material-ui/icons';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DownloadDialog = ({ open, onClose }) => {
    const handleDirectDownload = () => {
        window.open('/statics/irexchanger.apk', '_blank');
        onClose();
    };

    const handleBazaarDownload = () => {
        window.open('https://cafebazaar.ir/app/org.irexchanger.platform', '_blank');
        onClose();
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={onClose}
            aria-labelledby="download-dialog-title"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="download-dialog-title" style={{textAlign: 'center'}}>
                <div className='heading' style={{color: '#41C1F1'}}>
                    انتخاب روش دانلود
                </div>
            </DialogTitle>
            <DialogContent>
                <div className='download-dialog-content'>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        className='text'
                        startIcon={<GetApp />}
                        onClick={handleDirectDownload}
                        fullWidth
                        style={{
                            borderRadius: 12,
                            padding: '8px',
                            fontSize: '1.1rem',
                            fontWeight: 'bold'
                        }}
                    >
                        دانلود مستقیم
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="large"
                        className='text'
                        startIcon={<Store style={{color: 'var(--text-color)'}}/>}
                        onClick={handleBazaarDownload}
                        fullWidth
                        style={{
                            borderRadius: 12,
                            padding: '8px',
                            fontSize: '1.1rem',
                            fontWeight: 'bold'
                        }}
                    >
                        <div className='text'>
                            دانلود از کافه‌بازار
                        </div>
                    </Button>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" style={{padding: '0px !important'}}>
                    <div className='text'>
                        انصراف
                    </div>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DownloadDialog; 